import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import lt from './translations/lt.json';
import en from './translations/en.json';
import { getLanguage } from '../helpers/localStorageService';
import { defaultLanguage } from './language';

export const resources = { lt, en };

i18next.use(initReactI18next).init({
  resources,
  lng: getLanguage() ?? defaultLanguage.key,
  fallbackLng: defaultLanguage.key,
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
});

export default i18next;
